import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ComplicationsService {

	constructor(private httpClient: HttpClient) {
	}

	queryComplicationNames(queryTerm: string, skip: number, take: number) {
		return this.httpClient.get<string[]>(`/api/complications/names?queryTerm=${queryTerm}&skip=${skip}&take=${take}`);
	}
}